import { Selection } from "../../models/Selection";
import { SelectionType, Position } from "../../helpers/enum";
import { LineGroup } from "sb-resp-lib";

/* tslint:disable:cyclomatic-complexity */

export class SelectionParser {

    public static LineGroupParse(lineGroupData: LineGroup, type: SelectionType): Selection[] {
        let selectionArray: Selection[] = [];
        switch (type) {
            case SelectionType.ML: {
                selectionArray = this.CreateMLSelections(lineGroupData);
                break;
            }
            case SelectionType.HC: {
                let spread = lineGroupData.Spread;
                if (spread.ID1 && spread.ID3) {
                    let selection1 = this.CreateSelection((spread.ID1).toString(), "",
                        spread.Odds1 * 1, Position.Left, SelectionType.HC, spread.BetType * 1, spread.Points1 * 1);
                    let selection3 = this.CreateSelection((spread.ID3).toString(), "",
                        spread.Odds3 * 1, Position.Right, SelectionType.HC, spread.BetType * 1, spread.Points1 * 1);

                    selectionArray.push(selection1, selection3);
                }
                break;
            }
            case SelectionType.OU: {
                let ou = lineGroupData.OU;
                if (ou.ID1 && ou.ID3) {
                    let selection1 = this.CreateSelection(ou.ID1.toString(), "",
                        ou.Odds1 * 1, Position.Center, SelectionType.OU, ou.BetType * 1, ou.Points1 * 1);
                    let selection3 = this.CreateSelection(ou.ID3.toString(), "",
                        ou.Odds3 * 1, Position.Right, SelectionType.OU, ou.BetType * 1, ou.Points1 * 1);

                    selectionArray.push(selection1, selection3);
                }
                break;
            }
            case SelectionType.QA: {

                if (lineGroupData.ID) {
                    let position = Position.None;

                    switch (lineGroupData.QATypeParameter1) {
                        case 1714:
                        case 6:
                            position = Position.Left
                            break;
                        case 7:
                            position = Position.Center
                            break;
                        case 1715:
                        case 8:
                            position = Position.Right
                            break;
                        default:
                    }

                    let selection = this.CreateSelection(lineGroupData.ID.toString(), lineGroupData.LineName, lineGroupData.Odds * 1,
                        position, SelectionType.QA, lineGroupData.LineTypeID * 1, 0)

                    selectionArray.push(selection);
                }
                break;
            }
            default: {
                break;
            }
        }
        return selectionArray;
    }

    private static CreateMLSelections(lineGroupData: LineGroup): Selection[] {
        let selectionArray: Selection[] = [];
        let ml = lineGroupData.ML;

        if (ml.ML1_ID && ml.ML3_ID) {
            let selection1 = this.CreateSelection(ml.ML1_ID ? ml.ML1_ID.toString() : "", "",
                ml.ML1_Odds * 1, Position.Left, SelectionType.ML, ml.BetType * 1, 0);
            let selection2 = this.CreateSelection(ml.ML2_ID ? ml.ML2_ID.toString() : "", "",
                ml.ML2_Odds * 1, Position.Center, SelectionType.ML, ml.BetType * 1, 0);
            let selection3 = this.CreateSelection(ml.ML3_ID ? ml.ML3_ID.toString() : "", "",
                ml.ML3_Odds * 1, Position.Right, SelectionType.ML, ml.BetType * 1, 0);

            selectionArray.push(selection1);
            selectionArray.push(selection2);
            selectionArray.push(selection3);
        }
        return selectionArray;
    }

    private static CreateSelection(id: string, title: string, odds: number,
        position: Position, type: SelectionType, lineType: number, points: number): Selection {

        return new Selection({
            id,
            title,
            odds,
            position,
            type,
            lineType,
            points
        })
    }
}